import { useContext } from "react";

import { AuthApiContext } from "@/contexts/authenticated-api/AuthApiProvider";

import { useOrganizationId } from "./useOrganizationId";

/**
 * Custom hook for fetching airplanes for the current organization.
 */
export function useAirplanes() {
  const { $authApi, $api } = useContext(AuthApiContext);
  const organizationId = useOrganizationId();

  const api: typeof $authApi = $authApi ?? $api;

  return api.useQuery(
    "get",
    "/organizations/{organizationId}/airplanes",
    {
      params: {
        path: { organizationId: organizationId as number },
      },
    },
    {
      enabled: Boolean($authApi && organizationId),
    },
  );
}
